<template>
	<div class="page-history">
		<div class="header">
			<div class="header-icon"></div>
			<div class="header-input">
				<input type="number" v-model="uniqueId" @input="inputChange" placeholder="请输入设备编号" />
			</div>
			<div class="header-btn" @click="onclickSearchBtn">搜索</div>
			<div class="header-scan" @click="onclickScanBtn">
				<img :src="ossHost + 'img/scan.png'" />
			</div>
		</div>

		<div class="list" v-if="list.length">
			<div class="list-item" v-for="(item, index) in list" :key="index" @click="onclickListItem(item)">
				<img :src="ossPondHost + 'img/xiazeng_icon.png'" />
				<div class="item-num">{{ item.uniqueId }}</div>
				<div class="item-content">
					<div class="item-content-name">{{ item.operationName }}</div>
					<div class="item-content-time">{{ item.time }}</div>
				</div>
			</div>
			<div class="loading-text">{{ isShowAll ? '已展示全部记录' : '加载中...' }}</div>
		</div>

		<div class="empty-box" v-if="loaded && !list.length">
			<img :src="ossPondHost + 'img/empty_controller.png'" />
			<div class="empty-tip">暂无质检记录</div>
		</div>
	</div>
</template>

<script>
import { Toast } from 'vant';
export default {
	name: 'XiazengQaHistory',
	data() {
		const { ossHost, ossHostPond } = this.$config.base;
		return {
			ossHost,
			ossPondHost: ossHostPond,
			loaded: false,
			list: [],
			isShowAll: false,
			uniqueId: '',
			searchId: '',
			pageNo: 1,
			isShowClearBtn: false,
		};
	},
	created() {
		this.loadData();
		// 初始化微信 JSSDK
		this.weixinInit();
		// 绑定滚动事件
		window.addEventListener('scroll', this.handleScroll);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	methods: {
		weixinInit() {
			const vm = this;
			vm.$http({
				method: 'GET',
				url: `https://m.yudada.com/jssdk/configuration?url=${location.href}`,
			}).then(res => {
				const { appId, nonceStr, signature, timestamp } = res.data;
				window.wx.config({
					debug: false,
					appId,
					timestamp,
					nonceStr,
					signature,
					jsApiList: ['scanQRCode'],
				});
			});
		},

		onclickSearchBtn() {
			const vm = this;
			if (vm.uniqueId.length != 8) {
				Toast('请输入8位设备编码');
				return;
			}
			vm.searchId = vm.uniqueId;
			vm.pageNo = 1;
			vm.loadData();
		},

		// 加载质检记录
		loadData() {
			const vm = this;
			let url = `xia/factory/qcHistory?pageSize=20&pageNo=${vm.pageNo}`;
			if (vm.searchId) {
				url += `&uniqueId=${vm.searchId}`;
			}
			vm.$http({
				method: 'GET',
				url: vm.$config.base.XIAZENG_BASE_URL + url,
			}).then(res => {
				const data = res.data || {};
				const records = data.records || [];
				const total = data.total || 0;
				records.map(item => {
					item.time = vm.$time.formateTime(new Date(item.submitTime).getTime(), 'm-d h:f');
				});
				const list = vm.pageNo === 1 ? records : vm.list.concat(records);
				vm.loaded = true;
				vm.list = list;
				vm.isShowAll = list.length >= total;
			}).catch(() => {
				vm.loaded = true;
			});
		},

		// 滚动加载更多
		handleScroll() {
			const vm = this;
			if (vm.isShowAll) return;
			const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			const scrollHeight = document.documentElement.scrollHeight;
			const clientHeight = document.documentElement.clientHeight;
			if (scrollTop + clientHeight >= scrollHeight - 50) {
				vm.pageNo++;
				vm.loadData();
			}
		},

		inputChange() {
			const vm = this;
			if (!vm.uniqueId) {
				vm.searchId = '';
				vm.pageNo = 1;
				vm.loadData();
			}
			vm.isShowClearBtn = !!vm.uniqueId;
		},

		// 扫码搜索
		onclickScanBtn() {
			const vm = this;
			if (window.wx && window.wx.scanQRCode) {
				window.wx.scanQRCode({
					needResult: 1,
					scanType: ['qrCode'],
					success(res) {
						const result = res.resultStr;
						if (!(result && result.split('deviceId=')[1])) {
							Toast('编号错误，请确认后重试');
							return;
						}
						const encodeId = result.split('deviceId=')[1];
						// 根据加密的设备ID获取8位uniqueID
						vm.$http({
							method: 'GET',
							url: vm.$config.base.PROBE_BASE_URL + `device/info?encodeId=${encodeId}`,
						}).then(rs => {
							vm.uniqueId = rs.data.uniqueId;
							vm.isShowClearBtn = true;
							vm.searchId = rs.data.uniqueId;
							vm.pageNo = 1;
							vm.loadData();
						});
					},
				});
			} else {
				Toast('请在微信中扫码');
			}
		},

		// 查看某一记录的质检详情
		onclickListItem(item) {
			this.$router.push({
				path: './qaDetail',
				query: { info: JSON.stringify(item) },
			});
		},
	},
};
</script>

<style lang="less" scoped>
@import '@/less/base.less';

.page-history {
	min-height: 100vh;
	background: @bgColor2;
	padding: 0.15rem 0.13rem;
	font-size: 0.18rem;
	color: @textColor1;
	box-sizing: border-box;

	.header {
		position: static;
		top: 0.15rem;
		background: @blank;
		height: 0.4rem;
		line-height: 0.4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		&-icon {
			position: relative;
			width: 0.18rem;
			height: 0.18rem;
			border-radius: 0.09rem;
			border: 2px solid @themeColor;
			box-sizing: border-box;
			margin-left: 0.15rem;

			&:after {
				content: ' ';
				display: block;
				width: 0.05rem;
				border-top: 2px solid @themeColor;
				position: absolute;
				transform: rotate(45deg);
				right: -0.04rem;
				bottom: -0.01rem;
			}
		}

		&-input input {
			width: 1.75rem;
			height: 0.4rem;
			line-height: 0.4rem;
			padding-left: 0.1rem;
			border: none;
			outline: none;
			font-size: 0.16rem;
		}

		&-btn {
			width: 0.7rem;
			color: @themeColor;
			text-align: center;
			cursor: pointer;
		}

		&-scan {
			height: 0.4rem;
			background: @blank;
			width: 0.45rem;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;

			img {
				width: 0.25rem;
				height: 0.25rem;
			}
		}
	}

	.empty-box {
		padding: 0.7rem 0.35rem;
		text-align: center;

		img {
			width: 2rem;
			height: 2rem;
			margin: 0 auto 0.15rem;
			display: block;
		}

		.empty-tip {
			font-size: 0.19rem;
			text-align: center;
			letter-spacing: 2px;
		}
	}

	.list {
		padding-top: 0.2rem;

		&-item {
			position: relative;
			background: @blank;
			border-radius: 0.05rem;
			padding: 0.1rem;
			box-shadow: 0px 0px 6px 4px rgba(0, 0, 0, 0.05);
			padding-left: 0.8rem;
			margin-bottom: 0.2rem;
			cursor: pointer;

			img {
				position: absolute;
				left: 0.15rem;
				width: 0.55rem;
				height: 0.55rem;
				top: 0.12rem;
			}

			.item-num {
				font-weight: bold;
				padding-bottom: 0.1rem;
			}

			.item-content {
				display: flex;
				justify-content: space-between;
				font-size: 0.16rem;

				div {
					width: 50%;
				}
			}
		}

		.loading-text {
			text-align: center;
			font-size: 0.16rem;
			padding-top: 0.15rem;
		}
	}
}
</style>
